import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useConfirmPayment() {
  const { t } = useTranslation(['payments', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { patcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const confirmPayment = async (paymentId: string) => {
    setLoading(true)
    setError(null)
    setSuccess(null)

    try {
      await patcher<void>(
        `${CONFIG.BOUNCE_API}/api/v1/payments/${paymentId}/confirm`
      )
      setSuccess(t('payments:payments.hook.successfully-confirmed'))
      return true
    } catch (caughtError) {
      const message =
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      setError(message)
      throw new Error(message)
    } finally {
      setLoading(false)
    }
  }

  return { confirmPayment, loading, error, success, resetState }
}
